import React, { useContext, useEffect, useState } from 'react';
import image from '../img/bg6.jpg';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Paper } from '@material-ui/core';
import AccessAlarmOutlinedIcon from '@material-ui/icons/AccessAlarmOutlined';
import { Form, FormInput, FormSelect } from '../core/Formikfy';
import { db } from '../firebase';
import MenuItem from '@material-ui/core/MenuItem';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { Card } from '../components/Card/Card';
import CardContent from '@material-ui/core/CardContent';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { AutoCompleteInput } from '../components/AutoCompleteInput/AutoCompleteInput';
import { CustomTreeView } from '../components/TreeView/CustomTreeView';
import Footer from '../core/Layout/Footer';
import { AuthContext } from '../contexts/AuthContext';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundImage: `url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    alignText: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100%',
    color: 'white',
  },

  appBar: {
    height: '100px',
  },
  title: {
    color: 'white',
    fontFamily: '["Roboto", "Helvetica", "Arial", sans-serif]',
    margin: '100px auto',
  },
  card: {
    alignContent: 'center',
    justifyContent: 'center',
  },
  paper: {
    [theme.breakpoints.down('sm')]: {
      padding: '10px 10px 10px 10px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '20px 50px',
    },
  },
  heading: {
    color: 'white',
    fontFamily: '["Roboto", "Helvetica", "Arial", sans-serif]',
    fontWeight: 100,
    textAlign: 'left',
  },
  subHeading: {
    color: 'rgba(255,255,255,.62)',
    fontFamily: '["Roboto", "Helvetica", "Arial", sans-serif]',
    marginTop: '10px',
    fontWeight: 100,
    fontSize: '16px',
    textAlign: 'left',
  },
  formContent: {
    margin: '20px 0',
  },

  icon: {
    color: '#757575',
  },
  cardHeader: {
    textAlign: 'center',
    borderRadius: '2px',
    padding: '20px 30px',
    margin: '-80px 20px 0',
    backgroundColor: theme.palette.secondary.main,
  },
  button: {
    margin: '20px',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  formInput: {
    marginLeft: '10px',
  },
}));
export const Membership = () => {
  const classes = useStyles();
  const { currentUser } = useContext(AuthContext);

  //Collections
  const [membership, setMembership] = useState<any>([]); //list of documents in membership collection
  const [profiles, setProfiles] = useState<any>([]); //list of documents in profiles collection, doc id included, name = fName + lName
  const [profileInfo, setProfileInfo] = useState<any>();

  //Term State
  const [term, setTerm] = useState(''); //current selected term
  const [termItems, setTermItems] = useState([]); //list of terms
  const [addTermDialogBox, setAddTermDialogBox] = useState(false); // Add term dialog box open/close

  //Team State
  const [team, setTeam] = useState(''); //current selected team
  const [teamItems, setTeamItems] = useState<any>([]); //list of team objects , key - team name, value - list of member objects in the team
  const [addTeamDialogBox, setAddTeamDialogBox] = useState(false); // Add team dialog box open/close

  //Add Member
  const AIESECRoles = ['LCP', 'LCVP', 'Manager', 'Team Leader', 'Specialist', 'Team Member'];
  const [addMemberDialogBox, setAddMemberDialogBox] = useState(false); // Add team dialog box open/close
  const [position, setPosition] = useState('Team Member');
  const [autoCompleteOption, setAutoCompleteOption] = useState<any>({});

  //Tree View Info
  const [treeViewRender, setTreeViewRender] = useState(false);

  useEffect(() => {
    const membership = async () => {
      const membershipList = [];
      const termItemsList = [];
      const profileList = [];

      const membership = await db.collection('membership').get();
      const profiles = await db.collection('profile').get();
      const profile = await db.collection('profile').doc(currentUser.uid).get();
      console.log(membership);
      console.log(profile.data());
      if (membership.empty) {
        console.log('No matching documents in membership collection.');
        return;
      }
      if (profiles.empty) {
        console.log('No matching documents in profiles collection.');
        return;
      }
      membership.forEach((doc) => {
        membershipList.push(doc.data());
        termItemsList.push(doc.data().term);
      });
      const teamItemsList = Object.keys(membershipList[membershipList.length - 1].team);
      profiles.forEach((doc) => {
        profileList.push({
          name: `${doc.data().firstName} ${doc.data().lastName}`,
          dp: doc.data().dp_url,
          positions: doc.data().positions,
          email: doc.data().email,
          id: doc.id,
        });
      });

      setProfileInfo(profile.data());
      setMembership(membershipList);
      setProfiles(profileList);
      setTerm(termItemsList[termItemsList.length - 1]);
      setTermItems(termItemsList);
      setTeam('EB');
      setTeamItems(teamItemsList);
    };
    membership().then();
  }, []);

  const termChangeHandler = (value) => {
    const termDetails = membership.filter((doc) => doc.term === value)[0];
    setTerm(value);
    setTeamItems(Object.keys(termDetails.team));
    setTeam('EB');
    setTreeViewRender(!treeViewRender);
    setTreeViewRender(!treeViewRender);
  };

  const updateTreeView = async (data) => {
    const teamsList = membership.filter((doc) => doc.term === term)[0].team;
    const otherMembershipInfo = membership.filter((doc) => doc.term !== term);
    teamsList[team] = data;
    setMembership([...otherMembershipInfo, { term: term, team: teamsList }]);
    setTreeViewRender(!treeViewRender);
    await db
      .collection('membership')
      .where('term', '==', term)
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (document) {
          document.ref.update({ team: teamsList });
        });
      });
  };
  if (!profileInfo) {
    return <div></div>;
  }
  return (
    <Grid>
      <Grid item className={classes.container}>
        <div className={classes.appBar} />
        <Grid container component="main" className={classes.card}>
          <Grid item xs={10} sm={8}>
            <Paper elevation={3} className={classes.paper} style={{ minHeight: '80vh' }}>
              <Grid container>
                <Grid
                  justifyContent="center"
                  spacing={1}
                  container
                  item
                  xs={12}
                  md={5}
                  alignItems="flex-end"
                >
                  {/*Term Select*/}
                  <Grid item xs={1}>
                    <AccessAlarmOutlinedIcon color="action" />
                  </Grid>
                  <Grid item xs={8} className={classes.formInput}>
                    <Form
                      className={classes.form}
                      initialValues={{
                        term: term,
                      }}
                      onSubmit={async () => {
                        try {
                        } catch (e) {
                          console.error(e);
                        }
                      }}
                    >
                      <FormSelect
                        id="term"
                        label="Term"
                        type="text"
                        name="term"
                        value={term}
                        onChange={(event) => termChangeHandler(event.target.value)}
                        variant="standard"
                        fullWidth={true}
                      >
                        {termItems.map((item, index) => (
                          <MenuItem value={item}>{item}</MenuItem>
                        ))}
                      </FormSelect>
                    </Form>
                  </Grid>

                  {/*Add a new Term*/}
                  {profileInfo.role === 'admin' && (
                    <Grid item xs={2}>
                      <Fab size="small" color="secondary" onClick={() => setAddTermDialogBox(true)}>
                        <AddIcon />
                      </Fab>
                      <Dialog open={addTermDialogBox} onClose={() => setAddTermDialogBox(false)}>
                        <DialogTitle>Add a new term</DialogTitle>
                        <Form
                          className={classes.form}
                          initialValues={{
                            term: '',
                          }}
                          onSubmit={async (data) => {
                            try {
                              setAddTermDialogBox(false);
                              setTermItems([...termItems, data.term]);
                              setMembership([
                                ...membership,
                                {
                                  team: { EB: [] },
                                  term: data.term,
                                },
                              ]);
                              await db
                                .collection('membership')
                                .add({
                                  team: { EB: [] },
                                  term: data.term,
                                })
                                .then();
                            } catch (e) {
                              console.error(e);
                            }
                          }}
                        >
                          <DialogContent>
                            <DialogContentText>Enter new term details</DialogContentText>
                            <div>
                              <Card elevation={3} style={{ marginTop: '20px' }}>
                                <CardContent>
                                  <FormInput
                                    type="text"
                                    label="Term"
                                    name="term"
                                    variant="standard"
                                    fullWidth={true}
                                  />
                                </CardContent>
                              </Card>
                            </div>
                          </DialogContent>
                          <DialogActions style={{ display: 'block' }}>
                            <Button
                              onClick={() => setAddTermDialogBox(false)}
                              color="primary"
                              style={{ marginLeft: '10px' }}
                            >
                              Cancel
                            </Button>
                            <Button
                              type="submit"
                              color="primary"
                              style={{ marginRight: '10px', float: 'right' }}
                            >
                              Add Term
                            </Button>
                          </DialogActions>
                        </Form>
                      </Dialog>
                    </Grid>
                  )}
                </Grid>

                <Grid
                  justifyContent="center"
                  spacing={1}
                  container
                  item
                  xs={12}
                  md={5}
                  alignItems="flex-end"
                >
                  {/*Team Select*/}
                  <Grid item xs={1}>
                    <AccessAlarmOutlinedIcon color="action" />
                  </Grid>
                  <Grid item xs={8} className={classes.formInput}>
                    <Form
                      className={classes.form}
                      initialValues={{
                        team: team,
                      }}
                      onSubmit={async () => {
                        try {
                        } catch (e) {
                          console.error(e);
                        }
                      }}
                    >
                      <FormSelect
                        id="team"
                        label="Team"
                        type="text"
                        name="team"
                        value={team}
                        onChange={(event) => setTeam(event.target.value)}
                        variant="standard"
                        fullWidth={true}
                      >
                        {teamItems.map((item) => (
                          <MenuItem value={item}>{item}</MenuItem>
                        ))}
                      </FormSelect>
                    </Form>
                  </Grid>

                  {/*Add a new Team*/}
                  {profileInfo.role === 'admin' && (
                    <Grid item xs={2}>
                      <Fab size="small" color="secondary" onClick={() => setAddTeamDialogBox(true)}>
                        <AddIcon />
                      </Fab>
                      <Dialog open={addTeamDialogBox} onClose={() => setAddTeamDialogBox(false)}>
                        <DialogTitle>Add a new team</DialogTitle>
                        <Form
                          className={classes.form}
                          initialValues={{
                            team: '',
                          }}
                          onSubmit={async (data) => {
                            try {
                              const teamsList = membership.filter((doc) => doc.term === term)[0]
                                .team;
                              const otherMembershipInfo = membership.filter(
                                (doc) => doc.term !== term
                              );
                              teamsList[data.team] = [];
                              setTeamItems([...teamItems, data.team]);
                              setMembership([
                                ...otherMembershipInfo,
                                { term: term, team: teamsList },
                              ]);
                              setAddTeamDialogBox(false);
                              await db
                                .collection('membership')
                                .where('term', '==', term)
                                .get()
                                .then(function (querySnapshot) {
                                  querySnapshot.forEach(function (document) {
                                    document.ref.update({ team: teamsList });
                                  });
                                });
                            } catch (e) {
                              console.error(e);
                            }
                          }}
                        >
                          <DialogContent>
                            <DialogContentText>Enter new team details</DialogContentText>
                            <div>
                              <Card elevation={3} style={{ marginTop: '20px' }}>
                                <CardContent>
                                  <FormInput
                                    type="text"
                                    label="Team"
                                    name="team"
                                    variant="standard"
                                    fullWidth={true}
                                  />
                                </CardContent>
                              </Card>
                            </div>
                          </DialogContent>
                          <DialogActions style={{ display: 'block' }}>
                            <Button
                              onClick={() => setAddTeamDialogBox(false)}
                              color="primary"
                              style={{ marginLeft: '10px' }}
                            >
                              Cancel
                            </Button>
                            <Button
                              type="submit"
                              color="primary"
                              style={{ marginRight: '10px', float: 'right' }}
                            >
                              Add Team
                            </Button>
                          </DialogActions>
                        </Form>
                      </Dialog>
                    </Grid>
                  )}
                </Grid>
                {/*Add new member to the team */}
                {profileInfo.role === 'admin' && (
                  <Grid item xs={12} sm={4} lg={3}>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      startIcon={<PersonAddIcon />}
                      onClick={() => setAddMemberDialogBox(true)}
                    >
                      Add Member
                    </Button>
                    <Dialog
                      disableEnforceFocus
                      open={addMemberDialogBox}
                      onClose={() => setAddMemberDialogBox(false)}
                      aria-labelledby="form-dialog-title"
                    >
                      <DialogTitle id="form-dialog-title">Add Member</DialogTitle>

                      <Form
                        className={classes.form}
                        initialValues={{ position: '' }}
                        onSubmit={async (data) => {
                          try {
                            const newMemberInfo = {
                              id: autoCompleteOption.id, // id of the profile
                              position: position,
                              positionName: data.positionName,
                            };
                            const teamsList = membership.filter((doc) => doc.term === term)[0].team;
                            const otherMembershipInfo = membership.filter(
                              (doc) => doc.term !== term
                            );

                            teamsList[team].push(newMemberInfo);
                            setMembership([
                              ...otherMembershipInfo,
                              { term: term, team: teamsList },
                            ]);
                            setAddTeamDialogBox(false);
                            setTreeViewRender(!treeViewRender);
                            const currentPositionList = profiles.filter(
                              (profile) => profile.id === autoCompleteOption.id
                            )[0].positions;
                            currentPositionList.push({
                              position: position,
                              name: data.positionName,
                              term: term,
                            });
                            await db
                              .collection('profile')
                              .doc(autoCompleteOption.id)
                              .update({ positions: currentPositionList });
                            await db
                              .collection('membership')
                              .where('term', '==', term)
                              .get()
                              .then(function (querySnapshot) {
                                querySnapshot.forEach(function (document) {
                                  document.ref.update({ team: teamsList });
                                });
                              });
                          } catch (e) {
                            console.error(e);
                          }
                        }}
                      >
                        {/*Add new team member dialog box*/}
                        <DialogContent>
                          <DialogContentText>Enter team member information</DialogContentText>
                          <div style={{ marginLeft: '10px' }}>
                            <FormSelect
                              type="text"
                              label="Position"
                              name="position"
                              value={position}
                              onChange={(event) => setPosition(event.target.value)}
                              variant="standard"
                              fullWidth={true}
                            >
                              {AIESECRoles.map((position) => (
                                <MenuItem value={position}>{position}</MenuItem>
                              ))}
                            </FormSelect>
                          </div>
                          <div style={{ marginLeft: '10px' }}>
                            <FormInput
                              type="text"
                              label="Position Name"
                              name="positionName"
                              variant="standard"
                              fullWidth={true}
                            />
                          </div>
                          <div style={{ marginLeft: '10px' }}>
                            <AutoCompleteInput
                              options={profiles}
                              optionHandler={(option) => (
                                setAutoCompleteOption(option), console.log(option)
                              )}
                            />
                          </div>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={() => setAddMemberDialogBox(false)} color="primary">
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            onClick={() => setAddMemberDialogBox(false)}
                            color="primary"
                          >
                            Add Member
                          </Button>
                        </DialogActions>
                      </Form>
                    </Dialog>
                  </Grid>
                )}

                {/*Tree View*/}
                <Grid item xs={12}>
                  {team && (
                    <CustomTreeView
                      treeViewInfo={membership.filter((doc) => doc.term === term)[0].team[team]}
                      profileInfo={profiles}
                      treeViewRender={treeViewRender}
                      updateTreeView={updateTreeView}
                      currentUserInfo={profileInfo}
                    />
                  )}
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      {/*Footer*/}
      <Grid item sm={12}>
        <Footer />
      </Grid>
    </Grid>
  );
};
